import { fillString } from '@local_modules/generic/string-template.js'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'

import htmlTemplateIndex from './index.html'
import { showTableSyncs } from './show-table.js'

import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'
import { loadAllSyncs } from './load.js'

/**
 * Displays the admin list of data syncs for a given accounting organisation.
 *
 * Prepares and injects the HTML for the syncs list into the specified container element,
 * applies necessary restrictions, sets the page title, loads all syncs, and displays them in a table.
 *
 * @async
 * @param {Object} params - The parameters for displaying the syncs list.
 * @param {string} params.containerElementId - The ID of the container element where the HTML will be injected.
 * @param {Object} params.browserAppUser - The current browser app user object.
 * @param {Object} params.browserAppAccount - The current browser app account object.
 * @param {string} params.accountingOrganisationId - The ID of the accounting organisation to load syncs for.
 * @returns {Promise<void>} Resolves when the syncs list has been displayed.
 */
export async function showAdminListSyncs (params) {
  console.log('showAdminListSyncs', params)

  const { containerElementId, browserAppUser, browserAppAccount, accountingOrganisationId } = params

  if (!checkPageRestriction({ browserAppUser, allowNoAccount: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex

  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  document.getElementById(containerElementId)?.classList.add('position-absolute')
  document.getElementById(containerElementId)?.classList.add('top-to-bottom')

  // Set page title
  document.title = ['Data Syncs'].join(' ')

  const syncsResponse = await loadAllSyncs(accountingOrganisationId)

  showTableSyncs(syncsResponse)
}
